module.exports = __webpack_public_path__ + "files/4f07be0d86742e5cfa860c489babf82d.png";